import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
const taskVuex = createNamespacedHelpers("task");
import vailcode from "@utils/errcode";
import formatter from "@utils/formatter";
export default {
  name: "popShare",
  props: {},
  computed: {
    ...walletVuex.mapState(["setting"]),
    ...taskVuex.mapState(["timerObjs"]),
    fmt_pre() {
      return formatter.fmt_pre;
    }
  },
  data() {
    return {
      popGetToTelegramShow: false,
      isGetToTelegramConfirm: false,
      isBtnLoading: false,
      popSellPlatformShow: false,
      rowTrade: null,
      userInfo: null,
      logInfo: null,
      rowNewTrade: null,
      order_id: null,
      isShowClose: false
    };
  },
  watch: {
    popGetToTelegramShow: {
      handler(bool) {
        if (!bool) {
          this.isBtnLoading = false;
          console.log(66666);
          this.isShowClose = false;
          clearTimeout(this.timerObjs.giftPage.getTelegramNFTTimer);
        }
      },
      deep: true
    }
  },
  methods: {
    ...userVuex.mapMutations(["setUserData"]),
    onOpenRobit() {
      this.isShowClose = true;
      if (!this.rowTrade.gift_type) {
        _v.WebApp.openTelegramLink("https://t.me/TapCoinsBot");
      } else {
        _v.WebApp.openTelegramLink("https://t.me/memesGlo");
      }
    },
    luckyTradeFn(type) {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/lucky/lottery/trade", {
          id: this.rowTrade.id,
          type
        });
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            this.isBtnLoading = false;
            resolve();
            return;
          }
          this.userInfo = data.user;
          this.logInfo = data.info;
          this.order_id = this.logInfo.order_id;
          console.log("this.order_idthis.order_id", this.order_id);
          resolve(data);
        }, () => {
          this.isBtnLoading = false;
          resolve();
        });
      });
    },
    popGetToTelegramShowFnc(bool = true, item) {
      this.userInfo = null;
      this.logInfo = null;
      this.rowTrade = {
        order_id: this.order_id,
        ...item
      };
      this.rowNewTrade = {
        order_id: this.order_id,
        ...item
      };
      console.log("this.rowTradethis.rowTradethis.rowTrade222", this.rowTrade);
      this.checkToTelegramNFT(this.rowTrade);
      this.popGetToTelegramShow = bool;
    },
    async checkGiftTrade(rowTrade) {
      const res = await _v.$http.post("/lucky/lottery/tradeStatus", {
        orderId: rowTrade.order_id
      });
      console.log("reeeee", res);
      if (res.code > 0) {
        clearTimeout(this.timerObjs.giftPage.getTelegramNFTTimer);
        return;
      }
      if (!res.data) {
        clearTimeout(this.timerObjs.giftPage.getTelegramNFTTimer);
        return;
      }
      if (res.data.order_status <= 0) {
        this.timerObjs.giftPage.getTelegramNFTTimer = setTimeout(async () => {
          await this.checkToTelegramNFT({
            ...rowTrade,
            order_status: res.data.order_status
          });
        }, 3000);
      } else {
        clearTimeout(this.timerObjs.giftPage.getTelegramNFTTimer);
        await this.checkToTelegramNFT({
          ...rowTrade,
          order_status: res.data.order_status
        });
        return;
      }
    },
    async checkToTelegramNFT(rowTrade, bool) {
      console.log("rowTrade.order_status", rowTrade.order_status);
      if (rowTrade) if (rowTrade.order_status === null) {
        this.isGetToTelegramConfirm = false;
        this.isShowClose = true;
      } else if (rowTrade.order_status === 0) {
        await this.checkGiftTrade(rowTrade);
        this.isGetToTelegramConfirm = true;
        if (bool) {
          this.isShowClose = false;
        } else {
          this.isShowClose = true;
        }
      } else if (rowTrade.order_status === 1 || rowTrade.order_status === 2) {
        this.setUserData(this.userInfo);
        this.isBtnLoading = false;
        this.popGetToTelegramShow = false;
        this.$toasted.success("Successfully received the gift!");
        console.log("jjjjjjjjj", {
          ...this.rowNewTrade,
          ...rowTrade,
          ...this.logInfo,
          order_status: rowTrade.order_status
        });
        this.$emit("finish", "sell", {
          ...this.rowNewTrade,
          ...rowTrade,
          ...this.logInfo,
          order_status: rowTrade.order_status
        });
      }
    },
    async onGetToTelegrmaGet() {
      if (this.isBtnLoading) return;
      this.isBtnLoading = true;
      const res = await this.luckyTradeFn(1);
      if (!res) {
        this.isBtnLoading = false;
        return;
      }
      this.isShowClose = false;
      await this.checkToTelegramNFT(this.logInfo, true);
      if (this.logInfo.order_status === 0) {
        console.log(8888888888, this.logInfo);
        this.$emit("finish", "sell", this.logInfo);
      }
    },
    popSellPlatformShowFnc(bool = true, item) {
      this.logInfo = null;
      this.userInfo = null;
      this.rowTrade = {
        order_id: this.order_id,
        ...item
      };
      this.rowNewTrade = {
        order_id: this.order_id,
        ...item
      };
      this.popSellPlatformShow = bool;
    },
    async onSubmitSellPlatform() {
      if (this.isBtnLoading) return;
      this.isBtnLoading = true;
      const res = await this.luckyTradeFn(2);
      if (!res) {
        this.isBtnLoading = false;
        return;
      }
      if (this.$parent?.$refs?.nGiftHeadRef) {
        this.$parent.$refs.nGiftHeadRef.refreshFnc();
      }
      this.isBtnLoading = false;
      this.popSellPlatformShow = false;
      console.log("this.logInfo=======", this.logInfo);
      this.$toasted.success("Sold successfully");
      this.$emit("finish", "get", {
        ...this.rowNewTrade,
        ...this.rowTrade,
        ...this.logInfo
      });
    }
  }
};